<template>
  <component :is="contractData === undefined ? 'div' : 'b-card'">

    <!-- Alert: No item found -->
    <b-alert variant="danger" :show="contractData === undefined">
      <h4 class="alert-heading">
       {{ $t('Error fetching contract data')}}
      </h4>
      <div class="alert-body">
        {{ $t('No contract found with this contract id. Check')}}
        <b-link class="alert-link" :to="{ name: 'contracts.list'}">
          {{ $t('Contracts List')}}
        </b-link>
        {{ $t('for other contracts.')}}
      </div>
    </b-alert>

    <div class="loading_page" v-if="requestStatus">
      <orbit-spinner
          :animation-duration="1000"
          :size="100"
          :color="'#0e96b1'"
      />
    </div>

    <!-- Form -->
    <b-form v-if="contractData" @submit.prevent="submit">

      <!-- Name ar -->
      <b-form-group :label="$t('Name')" label-for="name">
        <b-form-input
            id="ar_name"
            v-model="contractData.name"
            autofocus
            :state="errors && ('name' in errors) ? false : null"
            trim
            autocomplete="off"
            :placeholder="$t('Name')"
        />

        <b-form-invalid-feedback :state="errors && ('name' in errors) ? false : null">
          {{ errors && ('name' in errors) ? $t(errors.name[0]) : null }}
        </b-form-invalid-feedback>

      </b-form-group>


      <!-- contractor -->
      <b-form-group :label="$t('Contractor')" label-for="contractor" :state="null">
        <v-select
            v-model="contractData.contractor_id"
            label="name"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="contractorsOptions"
            :reduce="val => val.id"
            :clearable="false"
            input-id="contractor"
        />
        <b-form-invalid-feedback v-if="(errors && ('contractor_id' in errors))" :state="(errors && ('contractor_id' in errors)) ? false : null">
          {{ $t(errors.contractor_id[0])  }}
        </b-form-invalid-feedback>
      </b-form-group>




      <!-- Color -->
      <b-form-group :label="$t('Color')" label-for="color">
        <b-form-input
            id="color"
            type="color"
            v-model="contractData.color"
            autofocus
            :state="errors && ('color' in errors) ? false : null"
            trim
            autocomplete="off"
            :placeholder="$t('Color')"
        />

        <b-form-invalid-feedback v-if="errors && ('color' in errors)" :state="errors && ('color' in errors) ? false : null">
          {{ errors.color[0] }}
        </b-form-invalid-feedback>

      </b-form-group>


      <b-col md="6" xl="2" class="mb-1">
        <!-- left char -->
        <b-form-group :label="$t('connected with CAP')" label-for="cap">
          <b-form-checkbox v-model="contractData.cap" :value="true" />

          <small v-if="errors && ('cap' in errors)" class="text-danger">
            {{ $t(errors['cap'][0]) }}
          </small>

        </b-form-group>
      </b-col>


      <b-col md="6" xl="2" class="mb-1">
        <!-- left char -->
        <b-form-group :label="$t('connected with MADINATI')" label-for="madinati">
          <b-form-checkbox v-model="contractData.madinati" :value="true" />

          <small v-if="errors && ('madinati' in errors)" class="text-danger">
            {{ $t(errors['madinati'][0]) }}
          </small>

        </b-form-group>
      </b-col>


      <b-col md="6" xl="2" class="mb-1">
        <!-- left char -->
        <b-form-group :label="$t('connected with amana riyadh')" label-for="amana_riyadh">
          <b-form-checkbox v-model="contractData.amana_riyadh" :value="true" />

          <small v-if="errors && ('amana_riyadh' in errors)" class="text-danger">
            {{ $t(errors['amana_riyadh'][0]) }}
          </small>

        </b-form-group>
      </b-col>


      <!-- Form Actions -->
      <div class="d-flex mt-2">
        <b-button variant="primary" class="mr-2" type="submit">
          {{ $t('Save')}}
        </b-button>
      </div>

    </b-form>


  </component>
</template>

<script>
import {
  BTab, BTabs, BCard, BAlert, BLink, BButton, BFormGroup, BFormInput, BForm, BFormTextarea,
  BFormInvalidFeedback, BCol, BFormCheckbox
} from 'bootstrap-vue'
import { onUnmounted } from '@vue/composition-api'
import store from '@/store'
import contractStoreModule from '@/views/modules/contract/store/contractStoreModule'
import { OrbitSpinner } from 'epic-spinners'
import useContractEdit from '@/views/modules/contract/contracts-edit/useContractEdit'
import vSelect from 'vue-select'

export default {
  components: {
    BFormCheckbox,
    BCol,
    BTab,
    BTabs,
    BFormTextarea,
    BFormInvalidFeedback,
    vSelect,
    BCard,
    BButton,
    BFormGroup,
    BFormInput,
    BForm,
    BAlert,
    OrbitSpinner,
    BLink,

  },
  setup(props, { root }) {

    const CONTRACT_STORE = 'app-contract'

    if (!store.hasModule(CONTRACT_STORE)) store.registerModule(CONTRACT_STORE, contractStoreModule)

    onUnmounted(() => {
      if (store.hasModule(CONTRACT_STORE)) store.unregisterModule(CONTRACT_STORE)
    })

    const { submit, requestStatus, errors, contractData, fetchContract, contractorsOptions } = useContractEdit(root)

    fetchContract()

    return {
      contractorsOptions,
      contractData,
      fetchContract,
      requestStatus,
      errors,
      submit
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
#add-new-type-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
